<template>
    <div class="history-management-view">
        <div class="documentmanagement-header">Review History</div>
        <DataSpanshot />
    </div>
</template>

<script setup>
    import { ref, computed, onMounted, watch, defineEmits } from 'vue'
    
    import CompanyAcounts from '@/components/CompanyAcounts.vue'
    import DataSpanshot from '@/components/DataSpanshot.vue'
    import API from '../api/index.js'
    import { useStore } from 'vuex'
    
    const store = useStore();
    const props = defineProps(['id']);
    const companyData = computed(() => store.state.companyData);

    onMounted(async() => {


        let data = await API.getSnapshotList(props.id);
        if (!companyData.value) {
            await API.loadDashboardData({company_id: props.id, snapshot_id: data.id});
            store.dispatch('loadEnv', { id: props.id } );
        }        
        store.dispatch('setValue', { key: 'labelYear', value: data.snapshots });
        document.title = 'Review History';
    })
</script>

<style lang="scss" scoped>

    .documentmanagement-header {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 20px;
        text-align: left;
        color: black;
        padding-top: 20px;
    }
    .history-management-view {
        display: flex;
        padding: 20px;
        flex-direction: column;
        max-width: 1350px;
        margin: auto;
    }

</style>